import { BaseApiService } from "./base-api-service";
import { IAddressType, ICounty, IDivision, IEmailType, IEthnicity, IGender, IPhoneType, IPreferredMethodOfContact, IState, ISuffix, IContactType } from '@/Models/Lookup'
import { IImprovProviderServiceDto } from "../Models/IImprovProviderServiceDto";

class lookupService extends BaseApiService {

    private static config = {
        headers: {
            'AuthorizationNeeded': false,
            // Other headers can be added here if needed
        }
    };
    public constructor() {
        super('Lookup/');
    }

    public async getDivisions() {
        return this.httpClient.get<IDivision[]>('DivisionList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
     
    public async getCounties() {
        return this.httpClient.get<ICounty[]>('CountyList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getEthnicities() {
        return this.httpClient.get<IEthnicity[]>('EthnicityList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getGenders() {
        return this.httpClient.get<IGender[]>('GenderList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getSuffixes() {
        return this.httpClient.get<ISuffix[]>('SuffixList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getPreferredMethodsOfContact() {
        return this.httpClient.get<IPreferredMethodOfContact[]>('PreferredMethodOfContactList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getAddressTypes() {
        return this.httpClient.get<IAddressType[]>('AddressTypeList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getStates() {
        return this.httpClient.get<IState[]>('StateList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getPhoneTypes() {
        return this.httpClient.get<IPhoneType[]>('PhoneTypeList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getEmailTypes() {
        return this.httpClient.get<IEmailType[]>('EmailTypeList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getContactTypes() {
        return this.httpClient.get<IContactType[]>('ContactTypeList', lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getCmAgencies(certificationTypeId: number, providerTypeId: number) {
        //return this.httpClient.get<IImprovProviderServiceDto[]>(`CmAgencyList?CertificationTypeId=${certificationTypeId}&ProviderTypeId=${providerTypeId}`, lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
        return this.httpClient.get<IImprovProviderServiceDto[]>(`CmStaffAgencyList?CertificationTypeId=${certificationTypeId}&ProviderTypeId=${providerTypeId}`, lookupService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));

    }
}

export const LookupService: lookupService = new lookupService();
